module.exports = __webpack_public_path__ + "static/img/logo-min.86dc3507.jpg";